import {RecordForm} from '../forms/RecordForm';


import {usePlaybook} from '../hooks/usePlaybook.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import {Playbook} from "../types.ts";


export const AddPage = () => {

    const navigate = useNavigate();
    const onCancel = () => {
        navigate('/playbooks');
    }

    const {
        record,
        createRecord,
    } = usePlaybook();

    return (
        <FormPageLayout
            title='Add Playbook'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as Playbook} handleSubmit={createRecord} handleCancel={onCancel}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
